import './TweenStudioLogo.css';

export function Logo({ className }: { className?: string }) {
  return (
    <span className={`tween-studio-logo ${className ?? ''}`.trim()}>
      <span className="tween-studio-logo-brand">tween</span>
      <span className="tween-studio-logo-studio">.studio</span>
    </span>
  );
}
